'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchItemBiddingIfNeeded = exports.fetchCatalogBiddingIfNeeded = exports.getMyBidItemIds = exports.getBiddingInfos = exports.getBiddingInfo = exports.LOAD_CATALOG_BIDDING_SUCCESS = exports.LOAD_CATALOG_BIDDING_REQUEST = exports.LOAD_CATALOG_BIDDING_FAIL = exports.LOAD_ITEM_BIDDING_SUCCESS = exports.LOAD_ITEM_BIDDING_REQUEST = exports.LOAD_ITEM_BIDDING_FAIL = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends4 = require('babel-runtime/helpers/extends');

var _extends5 = _interopRequireDefault(_extends4);

exports.default = reducer;

var _user = require('../modules/user');

var _absenteeBid = require('../modules/absenteeBid');

var _api = require('../api');

var _cloneDeep = require('lodash/cloneDeep');

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = require('reselect');

var _difference = require('lodash/difference');

var _difference2 = _interopRequireDefault(_difference);

var _config = require('../modules/config');

var _home = require('../modules/home');

var _item = require('../modules/item');

var _similarItems = require('../modules/similarItems');

var _login = require('../modules/login');

var _ms = require('ms');

var _ms2 = _interopRequireDefault(_ms);

var _retractBid = require('../modules/retractBid');

var _loaded = require('./loaded');

var _union = require('lodash/union');

var _union2 = _interopRequireDefault(_union);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_ITEM_BIDDING_FAIL = exports.LOAD_ITEM_BIDDING_FAIL = 'la/domain/itemBidding/LOAD_FAIL';
var LOAD_ITEM_BIDDING_REQUEST = exports.LOAD_ITEM_BIDDING_REQUEST = 'la/domain/itemBidding/LOAD_REQUEST';
var LOAD_ITEM_BIDDING_SUCCESS = exports.LOAD_ITEM_BIDDING_SUCCESS = 'la/domain/itemBidding/LOAD_SUCCESS';

var LOAD_CATALOG_BIDDING_FAIL = exports.LOAD_CATALOG_BIDDING_FAIL = 'la/domain/catalogBidding/LOAD_FAIL';
var LOAD_CATALOG_BIDDING_REQUEST = exports.LOAD_CATALOG_BIDDING_REQUEST = 'la/domain/catalogBidding/LOAD_REQUEST';
var LOAD_CATALOG_BIDDING_SUCCESS = exports.LOAD_CATALOG_BIDDING_SUCCESS = 'la/domain/catalogBidding/LOAD_SUCCESS';

var REDUX_STORE_TIME_ITEM = (0, _ms2.default)('20s');

// reducer
var DEFAULT_STATE = {
    byId: {},
    loaded: {},
    loading: []
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var existing = void 0;
    var loaded = void 0;
    var loading = void 0;
    var time = void 0;

    switch (action.type) {
        case LOAD_ITEM_BIDDING_FAIL:
            return (0, _extends5.default)({}, state, {
                loading: (0, _difference2.default)(state.loading, [action.meta.itemId])
            });
        case LOAD_ITEM_BIDDING_REQUEST:
            return (0, _extends5.default)({}, state, {
                loading: (0, _union2.default)(state.loading, [action.payload])
            });
        case LOAD_ITEM_BIDDING_SUCCESS:
        case LOAD_CATALOG_BIDDING_SUCCESS:
            existing = (0, _cloneDeep2.default)(state.byId);
            loaded = (0, _extends5.default)({}, state.loaded);
            loading = (0, _cloneDeep2.default)(state.loading);
            time = action.meta.actionTime;

            action.payload.forEach(function (item) {
                existing[item.itemId] = (0, _extends5.default)({}, item);
                loaded[item.itemId] = time;
                loading = (0, _difference2.default)(loading, [item.itemId]);
            });
            return (0, _extends5.default)({}, state, {
                byId: existing,
                loaded: loaded,
                loading: loading
            });
        case _user.LOAD_BIDDER_DATA_SUCCESS:
        case _home.LOAD_HOME_DATA_SUCCESS:
        case _item.LOAD_ITEMS_SUCCESS:
        case _similarItems.LOAD_SIMILAR_ITEMS_SUCCESS:
        case _login.LOGIN_SUCCESS:
            existing = (0, _cloneDeep2.default)(state.byId);
            loaded = (0, _extends5.default)({}, state.loaded);
            loading = (0, _cloneDeep2.default)(state.loading);
            time = action.meta.actionTime;

            if (action.payload.biddingInfos) {
                action.payload.biddingInfos.forEach(function (item) {
                    existing[item.itemId] = (0, _extends5.default)({}, item);
                    loaded[item.itemId] = time;
                    loading = (0, _difference2.default)(loading, [item.itemId]);
                });
            }
            return (0, _extends5.default)({}, state, {
                byId: existing,
                loaded: loaded,
                loading: loading
            });
        case _user.LOG_OUT_BIDDER:
            existing = (0, _cloneDeep2.default)(state.byId);
            (0, _keys2.default)(existing).forEach(function (key) {
                var item = existing[key];
                item.bidderHasBid = false;
                item.bidderHasHighBid = false;
                item.bidderMaxBid = 0;
            });
            return (0, _extends5.default)({}, state, {
                byId: existing
            });
        case _absenteeBid.ABSENTEE_BID_SUCCESS:
            var itemId = action.meta.itemId;
            var _action$payload = action.payload,
                isReserveMet = _action$payload.isReserveMet,
                leadingBid = _action$payload.leadingBid;

            var newBidInfo = (0, _cloneDeep2.default)(state.byId[itemId]);
            newBidInfo.bidActivityCount = newBidInfo.bidActivityCount + 1;
            newBidInfo.bidderBidTimestamp = action.meta.actionTime;
            newBidInfo.bidderHasBid = true;
            newBidInfo.bidderHasHighBid = action.payload.isCurrentHighBid;
            newBidInfo.bidderMaxBid = Number(action.payload.currentBid);
            newBidInfo.leadingBid = leadingBid;
            newBidInfo.isReserveMet = isReserveMet;
            return (0, _extends5.default)({}, state, {
                byId: (0, _extends5.default)({}, state.byId, (0, _defineProperty3.default)({}, itemId, newBidInfo))
            });
        case _retractBid.RETRACT_BID_SUCCESS:
            var retractedItemId = action.payload;

            existing = (0, _cloneDeep2.default)(state.byId[retractedItemId]);
            existing.bidderHasBid = false;
            existing.bidderHasHighBid = false;
            existing.bidderMaxBid = 0;
            return (0, _extends5.default)({}, state, {
                byId: (0, _extends5.default)({}, state.byId, (0, _defineProperty3.default)({}, retractedItemId, existing))
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.domain.biddingInfo;
};
var globalStateSelector = function globalStateSelector(state) {
    return state;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var byIdSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.byId;
});

var loadedSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loaded;
});

var loadingSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loading;
});

var getBiddingInfo = exports.getBiddingInfo = (0, _reselect.createSelector)([byIdSelector, idSelector], function (byId, id) {
    return byId[id] || {
        bidActivityCount: 0,
        bidCount: 0,
        bidderBidTimestamp: 0,
        bidderHasBid: false,
        bidderHasHighBid: false,
        bidderMaxBid: 0,
        isReserveMet: false,
        itemId: id,
        leadingBid: 0
    };
});

var getLoadTimeForItemBidding = (0, _reselect.createSelector)([loadedSelector, idSelector], function (loaded, id) {
    return loaded[id] || 0;
});

var isItemBiddingLoading = (0, _reselect.createSelector)([loadingSelector, idSelector], function (loading, id) {
    return loading.includes(id);
});

var getBiddingInfos = exports.getBiddingInfos = (0, _reselect.createSelector)([globalStateSelector, idSelector], function (state, itemIds) {
    return itemIds.map(function (id) {
        return getBiddingInfo(state, id);
    });
});

var shouldFetchBiddingInfoForItem = (0, _reselect.createSelector)([idSelector, getLoadTimeForItemBidding, isItemBiddingLoading], function (itemId, loaded, loading) {
    if (!itemId) return false;
    var time = Date.now();
    var diff = time - loaded;
    if (diff < REDUX_STORE_TIME_ITEM) return false;
    return !loading;
});

var getMyBidItemIds = exports.getMyBidItemIds = (0, _reselect.createSelector)(byIdSelector, function (byId) {
    return (0, _keys2.default)(byId).map(function (key) {
        return byId[key];
    }).filter(function (item) {
        return item.bidderHasBid;
    }).map(function (item) {
        return item.itemId;
    });
});

/* ACTION CREATORS */
var fetchIfNeeded = function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(_ref2) {
        var catalogId = _ref2.catalogId,
            dispatch = _ref2.dispatch,
            getState = _ref2.getState;
        var state, authToken, deployment, response;
        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        state = getState();

                        if (!(0, _loaded.shouldFetchBiddingInfoForCatalog)(state, catalogId)) {
                            _context.next = 15;
                            break;
                        }

                        _context.prev = 2;
                        authToken = (0, _user.getAuthToken)(state);
                        deployment = (0, _config.getDeployment)(state);

                        dispatch({
                            meta: { actionTime: Date.now() },
                            payload: catalogId,
                            type: LOAD_CATALOG_BIDDING_REQUEST
                        });
                        _context.next = 8;
                        return _api.BiddingInfo.fetchCatalogBidding({ authToken: authToken, catalogId: catalogId, deployment: deployment });

                    case 8:
                        response = _context.sent;

                        dispatch({
                            meta: { actionTime: Date.now(), catalogId: catalogId },
                            payload: response.data,
                            type: LOAD_CATALOG_BIDDING_SUCCESS
                        });
                        _context.next = 15;
                        break;

                    case 12:
                        _context.prev = 12;
                        _context.t0 = _context['catch'](2);

                        dispatch({
                            error: true,
                            meta: { catalogId: catalogId },
                            payload: _context.t0,
                            type: LOAD_CATALOG_BIDDING_FAIL
                        });

                    case 15:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, undefined, [[2, 12]]);
    }));

    return function fetchIfNeeded(_x3) {
        return _ref.apply(this, arguments);
    };
}();

var fetchCatalogBiddingIfNeeded = exports.fetchCatalogBiddingIfNeeded = function fetchCatalogBiddingIfNeeded(catalogId) {
    return function (dispatch, getState) {
        return Array.isArray(catalogId) ? _promise2.default.all(catalogId.map(function (id) {
            return fetchIfNeeded({ catalogId: id, dispatch: dispatch, getState: getState });
        })) : fetchIfNeeded({ catalogId: catalogId, dispatch: dispatch, getState: getState });
    };
};

var fetchItemBiddingIfNeeded = exports.fetchItemBiddingIfNeeded = function fetchItemBiddingIfNeeded(itemId) {
    return function () {
        var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch, getState) {
            var state, authToken, deployment, response;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            state = getState();

                            if (!shouldFetchBiddingInfoForItem(state, itemId)) {
                                _context2.next = 17;
                                break;
                            }

                            _context2.prev = 2;
                            authToken = (0, _user.getAuthToken)(state);
                            deployment = (0, _config.getDeployment)(state);

                            dispatch({
                                meta: { actionTime: Date.now() },
                                payload: itemId,
                                type: LOAD_ITEM_BIDDING_REQUEST
                            });
                            _context2.next = 8;
                            return _api.BiddingInfo.fetchItemBidding({ authToken: authToken, deployment: deployment, itemId: itemId });

                        case 8:
                            response = _context2.sent;

                            dispatch({
                                meta: { actionTime: Date.now(), itemId: itemId },
                                payload: response.data,
                                type: LOAD_ITEM_BIDDING_SUCCESS
                            });
                            _context2.next = 15;
                            break;

                        case 12:
                            _context2.prev = 12;
                            _context2.t0 = _context2['catch'](2);

                            dispatch({
                                error: true,
                                meta: { itemId: itemId },
                                payload: _context2.t0,
                                type: LOAD_ITEM_BIDDING_FAIL
                            });

                        case 15:
                            _context2.next = 18;
                            break;

                        case 17:
                            return _context2.abrupt('return', _promise2.default.resolve({}));

                        case 18:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, undefined, [[2, 12]]);
        }));

        return function (_x4, _x5) {
            return _ref3.apply(this, arguments);
        };
    }();
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/biddingInfo.js
// module id = m9FA
// module chunks = 46